export const normalizeBooleanString = (value) => {
  if (typeof value !== "string") return value;
  return value.trim().toLowerCase();
};

export const isProductVisible = (product) => {
  if (!product) return false;

  const visibleValue = normalizeBooleanString(product.visible);
  const productVisibleValue = normalizeBooleanString(product.productVisible);

  // Нове поле: якщо явно false — товар прихований всюди.
  if (visibleValue === false || visibleValue === "false") return false;

  // Старе поле, яке вже є в проєкті.
  // Якщо productVisible існує, теж його враховуємо.
  if (Object.prototype.hasOwnProperty.call(product, "productVisible")) {
    return productVisibleValue === true || productVisibleValue === "true";
  }

  // Старі товари без visible/productVisible залишаються видимими.
  return true;
};

export const filterVisibleProducts = (products = []) => {
  if (!Array.isArray(products)) return [];
  return products.filter(isProductVisible);
};
